module.exports = __webpack_public_path__ + "static/media/ic_upload.f3e5a280.svg";